import { DataPipeline, DbTable } from '@finley-technologies/finley-types';

type RawTapeType = Extract<
  DbTable.ArtifactType,
  'rawLoanTape' | 'rawRepaymentTape' | 'rawSupplementalTape'
>;

/**
 * The drawer input a caller needs uploaded, e.g. a deliverable's tape. The
 * drawer still offers every input; it marks the ones that match.
 */
export type NeededInput = {
  creditFacilitySlug: string;
  match:
    | {
        artifactType: Extract<RawTapeType, 'rawLoanTape' | 'rawRepaymentTape'>;
        loanProductSlug: string;
      }
    | {
        artifactType: Extract<RawTapeType, 'rawSupplementalTape'>;
        artifactSlug: string;
      };
};

export const isNeededInput = ({
  neededInput,
  meshInput,
  artifact,
}: {
  neededInput: NeededInput;
  meshInput: DataPipeline.MeshInput;
  artifact: DataPipeline.Artifact;
}): boolean => {
  const { creditFacilitySlug, match } = neededInput;
  if (meshInput.type !== 'file' || artifact.type !== match.artifactType) {
    return false;
  }
  // an input without a credit facility serves every facility of the mesh
  if (
    meshInput.creditFacilitySlug !== null &&
    meshInput.creditFacilitySlug !== creditFacilitySlug
  ) {
    return false;
  }
  return 'loanProductSlug' in match
    ? meshInput.loanProductSlug === match.loanProductSlug
    : artifact.artifactSlug === match.artifactSlug;
};
